<template>
  <main class="min-h-screen bg-slate-50 text-slate-950 dark:bg-slate-950 dark:text-slate-50">
    <router-view />
  </main>
</template>
